import { app } from "@/services/firebaseService";
import { getFunctions, httpsCallable } from "firebase/functions";

export async function getCampDataArtifactUrl(params: {
  campSlug: string;
  runId: string;
  relPath: string;
  mode: "view" | "download";
}): Promise<{ url: string; filename: string }> {
  const functions = getFunctions(app, "us-east4");
  const fn = httpsCallable<
    { campSlug: string; runId: string; relPath: string; mode: "view" | "download" },
    { url: string; filename: string }
  >(functions, "getCampDataArtifactUrl");
  const res = await fn({
    campSlug: params.campSlug,
    runId: params.runId,
    relPath: params.relPath,
    mode: params.mode,
  });
  return { url: res.data.url, filename: res.data.filename };
}
